export default __webpack_public_path__ + "static/media/einvoice_dashboard.20990f36.png";